export default (value: string, maxLength = 100) => {
    if (typeof value === 'string' && value.length > maxLength) {
        return value.substr(0, maxLength - 3) + '...';
    }

    return value;
};
